import React, { memo } from 'react'
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio
} from '@mui/material'

const CustomRadio = ({
  label,
  checked = false,
  onChange,
  error,
  size,
  color = 'default',
  ...restProps
}) => {
  return (
    <FormControl required error={!!error} variant='standard' size={size}>
      <FormControlLabel
        label={label}
        onClick={() => onChange && onChange()}
        control={
          <Radio
            size={size}
            color={color}
            checked={checked}
            onChange={() => {}}
            sx={(theme) => ({
              color: error && theme.palette.error.main
            })}
            {...restProps}
          />
        }
      />

      {error && error.length ? <FormHelperText>{error}</FormHelperText> : ''}
    </FormControl>
  )
}

export default memo(CustomRadio)
